
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'

class WorkOrderHelper {

    static getStatusName(intl, status) {
        switch (status) {
            case 'new':
                return intl.formatMessage({
                    id: "work_order.status.new_label",
                    defaultMessage: "New",
                })
            case 'cancelled':
                return intl.formatMessage({
                    id: "work_order.status.cancelled_label",
                    defaultMessage: "Cancelled",
                })
            case 'completed':
                return intl.formatMessage({
                    id: "work_order.status.completed_label",
                    defaultMessage: "Completed",
                })
            case 'approved':
                return intl.formatMessage({
                    id: "work_order.status.approved_label",
                    defaultMessage: "Approved",
                })
            case 'revised':
                return intl.formatMessage({
                    id: "work_order.status.revised_label",
                    defaultMessage: "Revised",
                })
        }
    }

}

export default injectIntl(WorkOrderHelper)


// WEBPACK FOOTER //
// ./src/workorder/workorderhelper.jsx